export default [
  {
    id: 'answercard.mijuan.course_1',
    parentId: 'answercard.mijuan.course',
    value: '1',
    chName: '数学',
    enName: 'answercard.mijuan.course_1',
    sort: 1,
    children: null
  },
  {
    id: 'answercard.mijuan.course_2',
    parentId: 'answercard.mijuan.course',
    value: '2',
    chName: '语文',
    enName: 'answercard.mijuan.course_2',
    sort: 2,
    children: null
  },
  {
    id: 'answercard.mijuan.course_3',
    parentId: 'answercard.mijuan.course',
    value: '3',
    chName: '英语',
    enName: 'answercard.mijuan.course_3',
    sort: 3,
    children: null
  },
  {
    chName: '合订本',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.4',
    parentId: 'answercard.basicbook.course',
    sort: 4,
    value: '4'
  },
  {
    chName: '物理',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.5',
    parentId: 'answercard.basicbook.course',
    sort: 5,
    value: '5'
  },
  {
    chName: '化学',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.6',
    parentId: 'answercard.basicbook.course',
    sort: 6,
    value: '6'
  },
  {
    chName: '生物',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.7',
    parentId: 'answercard.basicbook.course',
    sort: 7,
    value: '7'
  },
  {
    chName: '政治',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.8',
    parentId: 'answercard.basicbook.course',
    sort: 8,
    value: '8'
  },
  {
    chName: '历史',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.9',
    parentId: 'answercard.basicbook.course',
    sort: 9,
    value: '9'
  },
  {
    chName: '地理',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.10',
    parentId: 'answercard.basicbook.course',
    sort: 10,
    value: '10'
  },
  {
    chName: '道德与法治',
    children: null,
    enName: 'nothing',
    id: 'answercard.basicbook.course.14',
    parentId: 'answercard.basicbook.course',
    sort: 14,
    value: '14'
  },
  {
    chName: '历史与社会',
    children: null,
    enName: '16',
    id: 'answercard.basicbook.course.16',
    parentId: 'answercard.basicbook.course',
    sort: 16,
    value: '16'
  }
]
